import selectOption from '@/store/dict/selectOptionDict'

export default function () {
  const columns = [
    {
      name: 'id',
      columnProps: {
        label: '应收ID',
        prop: 'id',
        width: 100,
      },
    },
    {
      name: 'content',
      columnProps: {
        label: '收款内容',
        prop: 'content',
      },
      getText: ({ row }) => this.formatEnumeration(this.freeTypeList)[row.content],
    },
    {
      name: 'relReceivableId',
      columnProps: {
        label: '关联单ID',
        prop: 'relReceivableId',
      },
    },
    {
      name: 'plateNo',
      columnProps: {
        label: '车牌号',
        prop: 'plateNo',
        width: 100,
      },
    },
    {
      name: 'sourceOrderType',
      columnProps: {
        label: '来源单类型',
        prop: 'sourceOrderType',
        minWidth: '130',
      },
      getText: ({ row }) => selectOption.sourceOrderTypeDict[row.sourceOrderType],
    },
    {
      name: 'sourceOrderId',
      columnProps: {
        label: '来源单ID',
        prop: 'sourceOrderId',
      },
    },
    {
      name: 'receivableDate',
      columnProps: {
        label: '应收日期',
        prop: 'receivableDate',
        width: 100,
      },
    },
    {
      name: 'receivableState',
      columnProps: {
        label: '收款状态',
        prop: 'receivableState',
      },
      getText: ({ row }) => selectOption.batchStateDict[row.receivableState],
    },
    {
      name: 'receivableAmount',
      columnProps: {
        label: '应收金额（元）',
        prop: 'receivableAmount',
        minWidth: '130',
      },
      getText: ({ row }) => this.numberWithCommas(row.receivableAmount),
    },
    {
      name: 'receivingAmount',
      columnProps: {
        label: '收款中金额（元）',
        prop: 'receivingAmount',
        minWidth: '150',
      },
      getText: ({ row }) => this.numberWithCommas(row.receivingAmount),
    },
    {
      name: 'receivedAmount',
      columnProps: {
        label: '已收金额（元）',
        prop: 'receivedAmount',
        minWidth: '130',
      },
      getText: ({ row }) => this.numberWithCommas(row.receivedAmount),
    },
    {
      name: 'remainAmount',
      columnProps: {
        label: '剩余应收金额（元）',
        prop: 'remainAmount',
        minWidth: '150',
      },
      getText: ({ row }) => this.numberWithCommas(row.remainAmount),
    },
  ]
  return { columns }
}
